import { useState } from "react";
import { Lightbulb } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export const SuggestSource = () => {
  const [open, setOpen] = useState(false);
  const [v, setV] = useState({ name: "", url: "", reason: "" });
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/source-suggestions", v);
      toast.success(data.duplicate ? "Someone has already suggested this source. It's waiting for review." : "Thanks! A Middle administrator will review your suggestion.");
      setOpen(false); setV({ name: "", url: "", reason: "" });
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button variant="outline" className="rounded-full" data-testid="suggest-source-btn"><Lightbulb size={15} className="mr-1.5" />Suggest a source</Button></DialogTrigger>
      <DialogContent data-testid="suggest-source-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl font-medium">Suggest a news source</DialogTitle>
          <DialogDescription>An administrator reviews every suggestion. Approved sources must be free to read, established and not propaganda from either side.</DialogDescription>
        </DialogHeader>
        <Input value={v.name} onChange={(e) => setV({ ...v, name: e.target.value })} placeholder="Name, e.g. The Example Times" data-testid="suggest-source-name" />
        <Input value={v.url} onChange={(e) => setV({ ...v, url: e.target.value })} placeholder="Website, e.g. example.com" data-testid="suggest-source-url" />
        <Textarea rows={3} value={v.reason} onChange={(e) => setV({ ...v, reason: e.target.value })} placeholder="Why should Middle add it? (optional)" data-testid="suggest-source-reason" />
        <Button className="rounded-full" disabled={busy || v.name.trim().length < 2 || v.url.trim().length < 4} onClick={send} data-testid="suggest-source-submit">{busy ? "Sending…" : "Send suggestion"}</Button>
      </DialogContent>
    </Dialog>
  );
};
